export const getCompetencyAssessorOptions = structure => {
  const structureTypeCode = structure.structure?.structure_type?.value_list_code

  if (!['STT02', 'STT05'].includes(structureTypeCode)) return null

  const selectedGroupId = structure.selected_assessor_group_id
  let assessorGroupOptions = []
  let assessorOptions = []
  let firstItem = {}
  let competencyArray = []

  switch (structureTypeCode) {
    case 'STT02': {
      firstItem = structure.result_item[0] || {}
      competencyArray = firstItem.result_competency || []
      competencyArray.forEach(result => {
        const assessorGroupId = +result.assessor_group_id
        const assessorGroupName = result.assessor_group_name
        const assessorId = +result.assessor_id
        const assessorName = result.assessor_name

        if (assessorGroupId) {
          const assessorGroupExists = assessorGroupOptions.find(
            current => current.key === assessorGroupId
          )
          if (!assessorGroupExists) {
            assessorGroupOptions = [
              ...assessorGroupOptions,
              {
                key: assessorGroupId,
                value: assessorGroupId,
                label: assessorGroupName
              }
            ]
          }
        }

        if (assessorId) {
          const assessorExists = assessorOptions.find(current => current.key === assessorId)
          if (!assessorExists && selectedGroupId === assessorGroupId) {
            assessorOptions = [
              ...assessorOptions,
              {
                key: assessorId,
                value: assessorId,
                label: assessorName
              }
            ]
          }
        }
      })
      break
    }
    case 'STT05': {
      const firstGroupAttrs = Object.entries(structure.result_item)[0]?.[1] || {}
      firstItem = firstGroupAttrs.items?.[0] || {}
      competencyArray = firstItem.result_competency || []
      competencyArray.forEach(result => {
        const assessorGroupId = +result.assessor_group_id
        const assessorGroupName = result.assessor_group_name
        const assessorId = +result.assessor_id
        const assessorName = result.assessor_name

        if (assessorGroupId) {
          const assessorGroupExists = assessorGroupOptions.find(
            current => current.key === assessorGroupId
          )
          if (!assessorGroupExists) {
            assessorGroupOptions = [
              ...assessorGroupOptions,
              {
                key: assessorGroupId,
                value: assessorGroupId,
                label: assessorGroupName
              }
            ]
          }
        }

        if (assessorId) {
          const assessorExists = assessorOptions.find(current => current.key === assessorId)
          if (!assessorExists && selectedGroupId === assessorGroupId) {
            assessorOptions = [
              ...assessorOptions,
              {
                key: assessorId,
                value: assessorId,
                label: assessorName
              }
            ]
          }
        }
      })
      break
    }
    default:
      break
  }
  return { assessorGroupOptions, assessorOptions }
}

const validateCommon = (structure, endDateRequired) => {
  let structureValid = true

  if (!structure.stage_id) {
    structureValid = false
  }

  if (!structure.end_date && endDateRequired) {
    structureValid = false
  }

  return structureValid
}

const validateSTT05 = (structure, endDateRequired) => {
  const selectedAssessorId = structure.selected_assessor_id
  let structureValid = true

  if (!selectedAssessorId) {
    structureValid = false
  }
  // Start validate result items (Detail Panel)
  Object.entries(structure.result_item).forEach(group => {
    const [, groupAttrs] = group
    const itemsValid = (groupAttrs.items || []).reduce((valid, item) => {
      const value =
        item.result_competency.find(result => +result.assessor_id === +selectedAssessorId) || null

      const expectation = parseFloat(value?.target_value) || 0
      const actualValue = parseFloat(value?.actual_value) || 0
      const required = value && actualValue >= expectation
      const isError = required && !value?.comment

      return valid && !isError
    }, true)

    structureValid = structureValid && itemsValid
  })

  if (!structure.stage_id) {
    structureValid = false
  }

  // Every structure must have end date
  if (!structure.end_date && endDateRequired) {
    structureValid = false
  }

  return structureValid
}

export const validateAppraisalData = (structure, endDateRequired) => {
  const structureTypeCode = structure?.structure?.structure_type?.value_list_code
  switch (structureTypeCode) {
    case 'STT05':
      return !validateSTT05(structure, endDateRequired)
    case 'STT01':
    case 'STT02':
    case 'STT03':
    case 'STT04':
    case 'STT06':
      return !validateCommon(structure, endDateRequired)
    default:
      return false
  }
}
